import PropTypes from 'prop-types'
import { useTranslation } from 'next-i18next'

// Internal components
import Svg from '../Svg/Svg'
import { useContext } from 'react'
import { UserContext } from '../../context/UserContext'

const Rating = (props) => {
  const { rating } = props

  const userContext = useContext(UserContext)

  // Translations
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )

  const iconModifiers = ['Rating-ratingIcon']
  if (!rating?.average || rating.average === 0) iconModifiers.push('has-norating')
  const ratingValue = rating?.average ? rating?.average.toString().replace('.', ',') : 0
  const ratingLabel = rating?.total === 1 ? t('RATING__REVIEW') : t('RATING__REVIEWS')

  return (
    <div className="Rating">
      <div className="Rating-bar">
        <Svg modifiers={iconModifiers} id="icon-full-star" />
        <span className="Rating-currentRating">{ratingValue}</span>
        <span className="Rating-totalRating">/</span>
        <span className="Rating-totalRating">5</span>
      </div>
      {rating?.total && (
        <div className="Rating-total">
          <span className="Rating-text">
            {rating.total} {ratingLabel}
          </span>
        </div>
      )}
    </div>
  )
}

Rating.propTypes = {
  rating: PropTypes.any.isRequired
}

export default Rating
